/**
 * External dependencies
 */
import React from 'react';
import { connect } from 'react-redux';
import { Stack, Box } from '@towersystems/towersystems-design-system';
import Skeleton from 'react-loading-skeleton';

/**
 * Internal dependencies
 */
import Main from 'components/main';
import Navigation from 'modules/dashboard/connections/navigation';
import AnnotatedSection from 'components/annotated-section';
import Card from 'components/card';

const AnnotatedSectionSkeleton = ({}) => {
    return (
        <Stack space='large'>
            <Box justifyContent='spaceBetween' alignItems='center' display='flex'>
                <Skeleton count={1} height={30} width={180} />
                <Skeleton count={1} height={30} width={100} />
            </Box>
            <Stack space='xlarge' dividers>
                <AnnotatedSection>
                    <AnnotatedSection.Annotation
                        title={null}
                        description={
                            <React.Fragment>
                                <Skeleton count={1} />
                                <Skeleton count={1} width='80%' />
                            </React.Fragment>
                        }
                    />
                    <AnnotatedSection.Content>
                        <Card>
                            <Card.Section>
                                <Skeleton count={4} />
                            </Card.Section>
                        </Card>
                    </AnnotatedSection.Content>
                </AnnotatedSection>
                <AnnotatedSection>
                    <AnnotatedSection.Annotation
                        title={null}
                        description={
                            <React.Fragment>
                                <Skeleton count={1} />
                                <Skeleton count={1} width='80%' />
                            </React.Fragment>
                        }
                    />
                    <AnnotatedSection.Content>
                        <Card>
                            <Card.Section>
                                <Skeleton count={4} />
                            </Card.Section>
                        </Card>
                    </AnnotatedSection.Content>
                </AnnotatedSection>
            </Stack>
        </Stack>
    );
};

export default connect((state) => ({}), {})(AnnotatedSectionSkeleton);
